module.exports = __webpack_public_path__ + "img/home2.d7967e2a.png";